import React from "react";

import Hero from "../components/Hero";
import Layout from "../components/Layout";
import { Container, Flex, Link, Text } from "@chakra-ui/react";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { ReactComponent as FlippedTriCube } from "../images/flipped-tri-cube.svg";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { HeadFC } from "gatsby";

export const communityLinks = [
  {
    title: "Stack Overflow",
    url: "https://stackoverflow.com/questions/tagged/graphql",
  },
  { title: "Reddit (/r/graphql)", url: "https://www.reddit.com/r/graphql/" },
  {
    title: "Community Forums",
    url: "https://community.apollographql.com?utm_campaign=graphql.com ",
  },
  { title: "Twitter", url: "https://twitter.com/apollographql" },
];

const CommunityPage = () => {
  return (
    <>
      <GatsbySeo
        title="GraphQL Community"
        description="Get involved with GraphQL community, share or find resources, best practices, ask questions and get unblocked."
      />
      <Layout>
        <Container p="10" maxW="7xl">
          <Hero
            center
            layout="vertical"
            title="Community"
            image={<FlippedTriCube />}
          >
            <Text>
              GraphQL is more fun with friends, so join the conversation!
              Whether you&apos;re an expert or an enthusiast, there&apos;s
              always room for one more in the GraphQL community.
            </Text>
          </Hero>
          <Flex
            flexWrap="wrap"
            flexDirection={{ base: "column", md: "row" }}
            textAlign={"center"}
            justifyContent="center"
          >
            {communityLinks.map((link, key) => (
              <Link
                isExternal
                display="inline-flex"
                alignItems="center"
                key={key}
                p="3"
                borderStyle="solid"
                borderColor="gray.200"
                borderWidth="1px"
                borderRadius="4px"
                color="blue.900"
                mx="2"
                mb="2"
                href={link.url}
                _hover={{
                  textDecoration: "none",
                  background: "purple.500",
                  color: "#fff",
                }}
                onClick={() => {
                  window.gtag?.("event", "community_link_click", {
                    title: link.title,
                  });
                }}
              >
                {link.title} &nbsp;
                <FiArrowRight />
              </Link>
            ))}
          </Flex>
        </Container>
      </Layout>
    </>
  );
};

export default CommunityPage;

export const Head: HeadFC = () => <title>Community - GraphQL.com</title>;
